import * as styles from './Divider.css';

export const Divider = () => <div className={styles.line} role="separator" />;
